import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, user } = useAuth();

  // Auto-navigate to admin panel after successful login for admin users
  useEffect(() => {
    if (isAuthenticated && user?.isAdmin) {
      navigate('/admin');
    }
  }, [isAuthenticated, user, navigate]);

  const handleNewReservation = () => {
    navigate('/new-reservation');
  };

  const handleEditReservation = () => {
    navigate('/edit-reservation');
  };

  const handleAdminPanel = async () => {
    if (!isAuthenticated) {
      // If not authenticated, trigger Microsoft login
      await login();
    } else {
      // Ook zonder rechten naar /admin: daar staat uitleg over hoe je toegang
      // krijgt, wat duidelijker is dan een kale melding.
      navigate('/admin');
    }
  };

  return (
    <div className="landing-page">
      <button 
        className="beheer-button"
        onClick={handleAdminPanel}
      >
        <span className="beheer-icon">⚙️</span>
        <span className="beheer-text">Beheer</span>
      </button>
      
      <div className="landing-container">
        <div className="bike-image-container">
          <img src="/bike-image.png" alt="Bike" className="bike-icon" />
          <h1>Duofiets Reservering Systeem</h1>
          <p>Welkom bij ons fiets reservering systeem</p>
        </div>
        
        <div className="options-container">
          <button 
            className="option-button new-reservation"
            onClick={handleNewReservation}
          >
            <span className="button-icon">➕</span>
            <span className="button-text">Nieuwe Reservering</span>
            <span className="button-description">Maak een nieuwe fiets reservering</span>
          </button>
          
          <button 
            className="option-button edit-reservation"
            onClick={handleEditReservation}
          >
            <span className="button-icon">✏️</span>
            <span className="button-text">Reservering Wijzigen</span>
            <span className="button-description">Bekijk en wijzig bestaande reserveringen</span>
          </button>
        </div>
        
        <div className="footer-info">
          <p>Kies een optie om te beginnen</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
